import Header from './ProductHeaderPage';

export default Header;
